import React, { forwardRef, useImperativeHandle, useRef, useState } from "react";
import { map, RCCGrid, RCCHierarchicalTree, RCCHookToast, RCCRefModalProps, RCCServicesApi } from "react-common-components";
import { useLoaderBackdrop } from "src/context/LoaderBackdrop/context";
import { useTranslation } from "src/context/Translations/context";
import { standardErrorMessages } from "src/utils/errors";
import Modal from "../Modal";
import ModalSide from "../Modal/styles";
import { IReorderActions, IReorderRef } from "./interface";
import TitleItemReorder from "./styles";

const ModalReorder: React.ForwardRefRenderFunction<IReorderRef, IReorderActions> = ({ 
	routeToList,
	routeToSave,
	names,
	modalName,
	onCallbackSave,
	badgeComponent
}, ref) => {

	const { translate } = useTranslation();
	const { addToast } = RCCHookToast();
	const { setLoading } = useLoaderBackdrop();

	const modalRef = useRef<RCCRefModalProps>(null);
	const [paramters, setParamters] = useState<any>(null);

	const [listData, setListData] = useState<Array<any>>([]);

	const [subtitleModal, setSubtitleModal] = useState("");

	const queryData = async (urlParameters: Object) => {
		setLoading(true);
		try{
			const { data } = await RCCServicesApi.getRequest({
				method: routeToList,
				urlParameters
			});
			setListData(data);
			modalRef.current?.openModal();
			setLoading(false);
		}catch(err: any){
			setLoading(false);
			standardErrorMessages(err, translate("Erro ao buscar dados"), addToast);
		}
	};
  
	const openModalReorder = (additionalUrlParameters: any, subtitle?: string) => {
		setSubtitleModal(subtitle ?? "");
		setParamters(additionalUrlParameters);
		queryData(additionalUrlParameters);
	};

	const submit =  async () => {	
		try{
			modalRef.current?.setLoadingButton();	

			const ListDTO = map({
				treeData:[...listData],
				getNodeKey:({treeIndex}:any) => treeIndex,
				ignoreCollapsed:false,
				callback:(info: any) => {
					const newNode = {...info.node};
					newNode[names.nameForOrder] = info.treeIndex+1;
					return newNode;
				}
			});
			await RCCServicesApi.postRequest({
				method: routeToSave,
				body: {
					ListDTO
				}
			});	

			if(onCallbackSave)
				onCallbackSave(paramters);

			addToast({
				color: "green",
				description: translate("Reordenação concluída com sucesso"),
				title: translate("Sucesso")
			});
			
			modalRef.current?.resetLoadingButton();
			modalRef.current?.closeModal();
		}catch(err){
			modalRef.current?.resetLoadingButton();
			standardErrorMessages(err,translate("Erro ao reordenar"),addToast);
		}	
	};

	useImperativeHandle(ref, () => ({
		openModalReorder
	}));

	return (
		<>
			<Modal
				ref={modalRef}
				header={{
					title: modalName,
					subtitle: subtitleModal ?? "",
					icon: {
						name: "infoCircle"
					}
				}}
				onSubmit={submit}
				styleInline={ModalSide}
			>
				<RCCGrid
					container
					item
					direction="column"
					alignItems="center"
				>
					<RCCGrid
						container
						item
						alignItems="center"
						justify="space-between"
					>
						<RCCHierarchicalTree
							data={listData.map((line) => ({
								...line,
								id: `${line.id}`
							}))}
							styleInline={`
								width:100%;
								.rst__tree{
									overflow: hidden;
								}
								.rst__node{
									height: fit-content !important;
									width: max-content;
    							overflow: hidden;
								}`
							}
							onChange={(treeData) => setListData(treeData)}
							canDrop={(data:any):boolean => data.nextParent?.[names.nameForId] === data.prevParent?.[names.nameForId]}
							customNode={({
								node
							}) => (
								<RCCGrid container>
									{!node.onChange && 
										<RCCGrid 
											container 
											alignItems="center"
											justify="space-between"
											style={{ minHeight: "30px" }}
										>
											<TitleItemReorder>{node[names.nameForTitle]}</TitleItemReorder>
											{badgeComponent && badgeComponent(node)}								
										</RCCGrid>
									}
								</RCCGrid>
							)}
						/>	
					</RCCGrid>			
				</RCCGrid>	
			</Modal>
		</>
	);
};

export default forwardRef(ModalReorder);
